import React from 'react'
import { Play, ArrowRight, Sparkles } from 'lucide-react'

const Hero: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-blue-900 text-white overflow-hidden">
      <div className="absolute inset-0 bg-[url('/api/placeholder/1920/1080')] opacity-5 bg-cover bg-center"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="text-center">
          {/* Main Headline */}
          <div className="flex items-center justify-center mb-6">
            <Sparkles className="w-8 h-8 text-blue-400 mr-3 animate-pulse" />
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold animate-fade-in">
              Welcome to <span className="text-blue-400">HammerMUD</span>
            </h1>
            <Sparkles className="w-8 h-8 text-blue-400 ml-3 animate-pulse" />
          </div>
          
          {/* Subtitle */}
          <p className="text-xl sm:text-2xl mb-4 text-gray-200 max-w-4xl mx-auto animate-fade-in leading-relaxed">
            Revitalizing text-based gaming for a new generation while honoring the rich traditions that made MUDs beloved
          </p>
          
          <p className="text-lg mb-8 text-gray-300 max-w-2xl mx-auto animate-fade-in">
            Experience the unique depth and creativity that only text adventures can offer, 
            enhanced with modern conveniences and design
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12 animate-fade-in">
            <a
              href="/app"
              className="inline-flex items-center px-8 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <Play className="w-5 h-5 mr-2" />
              Start Your Adventure
            </a>
            <a
              href="/about"
              className="inline-flex items-center px-8 py-4 border-2 border-blue-400 text-blue-400 rounded-lg hover:bg-blue-400 hover:text-white transition-all duration-200 font-semibold text-lg"
            >
              Learn Our Mission
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>

          {/* Value Props */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center bg-gray-800/50 rounded-lg p-6 border border-gray-700/50">
              <div className="text-2xl font-bold text-blue-400 mb-2">Text-Driven</div>
              <div className="text-gray-300">Imagination-powered gameplay that graphics can't match</div>
            </div>
            <div className="text-center bg-gray-800/50 rounded-lg p-6 border border-gray-700/50">
              <div className="text-2xl font-bold text-green-400 mb-2">Community</div>
              <div className="text-gray-300">A virtual third space for meaningful connections</div>
            </div>
            <div className="text-center bg-gray-800/50 rounded-lg p-6 border border-gray-700/50">
              <div className="text-2xl font-bold text-purple-400 mb-2">Modern MUD</div>
              <div className="text-gray-300">Classic MUD spirit with contemporary design</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 -mt-16 -mr-16 w-32 h-32 bg-blue-500 rounded-full opacity-10 animate-pulse"></div>
      <div className="absolute bottom-0 left-0 -mb-16 -ml-16 w-24 h-24 bg-purple-500 rounded-full opacity-10 animate-pulse"></div>
      <div className="absolute top-1/2 right-1/4 w-16 h-16 bg-green-500 rounded-full opacity-5 animate-ping"></div>
    </section>
  )
}

export default Hero